var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loading
    ? _c(
        "div",
        {
          staticClass: "dashboard",
          class: { "is-centered": _vm.emptyStatistics }
        },
        [
          _vm.emptyStatistics
            ? _c(
                "div",
                { staticClass: "box is-flex is-centered is-empty" },
                [
                  _c("BIcon", {
                    attrs: {
                      icon: "clipboard-alert-outline",
                      size: "is-large",
                      type: "is-primary",
                      "custom-size": "mdi-128px"
                    }
                  }),
                  _c("h2", { staticClass: "title is-2 has-text-primary" }, [
                    _vm._v("\n      Aún no has facturado\n    ")
                  ]),
                  _c(
                    "RouterLink",
                    {
                      staticClass: "button is-primary is-text",
                      attrs: { to: { name: "NewInvoice" } }
                    },
                    [
                      _vm._v(
                        "\n      Haz click aquí para comenzar a facturar.\n    "
                      )
                    ]
                  ),
                  _c("p", [_vm._v("ó")]),
                  _c(
                    "RouterLink",
                    {
                      staticClass: "button is-primary is-text",
                      attrs: { to: { name: "NewSaleNote" } }
                    },
                    [
                      _vm._v(
                        "\n      Haz click aquí para crear nota de remisión\n    "
                      )
                    ]
                  )
                ],
                1
              )
            : [
                _c("div", { staticClass: "columns is-multiline" }, [
                  _c("div", { staticClass: "column is-12-mobile is-4" }, [
                    _c("div", { staticClass: "box" }, [
                      _c(
                        "h3",
                        {
                          staticClass:
                            "indicator title is-4 title-dashboard-debt"
                        },
                        [
                          _c("div", [_vm._v("Total de deuda:")]),
                          _c(
                            "div",
                            {
                              staticClass:
                                "has-text-weight-bold has-text-debt-total"
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm._f("toCurrency")(_vm.totalDebt, "MXN")
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "column is-12-mobile is-4" }, [
                    _c("div", { staticClass: "box" }, [
                      _c(
                        "h3",
                        {
                          staticClass:
                            "indicator title is-4 title title-dashboard-debt-expired"
                        },
                        [
                          _c("div", [_vm._v("Total Vencido:")]),
                          _c(
                            "div",
                            {
                              staticClass:
                                "has-text-weight-bold has-text-debt-expired"
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm._f("toCurrency")(
                                      _vm.totalDebtExpired,
                                      "MXN"
                                    )
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "column is-12-mobile is-4" }, [
                    _c("div", { staticClass: "box" }, [
                      _c(
                        "h3",
                        {
                          staticClass:
                            "indicator title is-4 title-dashboard-debt-overcome"
                        },
                        [
                          _c("div", [_vm._v("Por Vencer:")]),
                          _c(
                            "div",
                            {
                              staticClass: "has-text-weight-bold has-text-debt"
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm._f("toCurrency")(
                                      _vm.totalDebt - _vm.totalDebtExpired,
                                      "MXN"
                                    )
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "column is-12-mobile is-6" }, [
                    _c(
                      "div",
                      { staticClass: "box" },
                      [
                        _c("apex-chart", {
                          staticClass: "debts-summary",
                          attrs: {
                            type: "bar",
                            options: _vm.barChartOptionsDebtsSummary,
                            series: _vm.seriesDebtsSummary
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "column is-12-mobile is-6" }, [
                    _c(
                      "div",
                      { staticClass: "box" },
                      [
                        _c("apex-chart", {
                          attrs: {
                            width: "400",
                            type: "pie",
                            options: _vm.chartOptions,
                            series: [_vm.totalDebtExpired, _vm.totalDebt]
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "column is-12-mobile is-4" },
                    [_c("StatisticsSalesYear")],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "column is-12-mobile is-4" },
                    [_c("StatisticsSalesMonth")],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "column is-12-mobile is-4" },
                    [_c("StatisticsSalesDay")],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "column is-6" },
                    [_c("StatisticsSalesItems")],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "column is-6" },
                    [_c("StatisticsSalesItemsAll")],
                    1
                  )
                ]),
                _vm.bottomUrlRedirect
                  ? _c("div", { staticClass: "is-centered" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.bottomUrlRedirect,
                            target: "__blank"
                          }
                        },
                        [_c("img", { attrs: { src: _vm.bottomBannerImg } })]
                      )
                    ])
                  : _vm._e()
              ]
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }